// extracted by mini-css-extract-plugin
module.exports = {"transactionHistory":"Transaction_transactionHistory__1TAq8","tableHead":"Transaction_tableHead__1B53Q","item":"Transaction_item__RdDgN","itemType":"Transaction_itemType__3uFm0"};